import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cff25d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mycollection-sub-header" }
const _hoisted_2 = { class: "the-global-header-nav" }
const _hoisted_3 = { class: "the-global-header-nav--list" }
const _hoisted_4 = { class: "the-global-header-nav--item item__logout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_AppButton, {
            class: "button-logout",
            styled: "is-none",
            onClick: _ctx.onLogout,
            onKeydown: _withKeys(_withModifiers(_ctx.onLogout, ["prevent"]), ["space","enter"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('label.logout')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])
        ])
      ])
    ])
  ]))
}